// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rTWO","brands":"styles_brands__3ZrJE","wideBrands":"styles_wideBrands__2-2Kd","brandsMobile":"styles_brandsMobile__1RkO9"};